import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Observable } from 'rxjs/internal/Observable';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatRadioChange } from '@angular/material/radio';
import { Clipboard } from "@angular/cdk/clipboard";
import { SendEmailNotificationComponent } from '../sendEmailNotification/sendEmailNotification.component';

@Component({
  selector: 'app-uploadAIDocuments',
  templateUrl: './uploadAIDocuments.component.html',
  styleUrls: ['./uploadAIDocuments.component.scss'],
})

export class UploadAIDocuments implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  transactionName: string = "";
  aITemplateList: any = [] = [];
  selectedFunction: any;
  transactionId: any;
  uploadedFiles: File[] = [];
  fieldTemplateID: number = 0;
  searchType: number = 0;

  constructor(public dialogRef: MatDialogRef<UploadAIDocuments>,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,
    private toastr: ToastrService, private statusConstant: StatusConstant,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.transactionName = this.data.Name;
    this.transactionId = this.data.transactionID;
    this.searchType = this.data?.searchType ?? 0;
    this.getAIAutomationTemplates();
  }

  getAIAutomationTemplates() {
    this.loaderService.show();
    var ReqModel = {
      keyword: "",
      searchType: this.searchType,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.coreService.getAIAutomationTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.aITemplateList = this.responseHolder.data.templates;
          if (this.aITemplateList == null) {
            this.aITemplateList = [];
          }
        }
        else {
          this.aITemplateList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.aITemplateList = [];
        this.loaderService.hide();
      }
    });
  }

  closepopup() {
    this.dialogRef.close();
  }


  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1);
  }

  onTemplateSelect(event: any) {
    this.fieldTemplateID = event.value;
  }


  parentId: number = 0;


  engagingMessages = [
    "Hang tight, we're uploading your file!",
    "Almost there! Your data is on its way.",
    "We’re making progress. Just a bit more patience!",
    "Your file is getting uploaded smoothly.",
    "Crunching data… great things take time!",
    "Uploading… this won’t take long!",
  ];

  showEngagingToaster = (fileName: string) => {
    let messageIndex = 0;
    const toastId = `upload-progress-${fileName}`;

    // Update the engaging message periodically
    const intervalId = setInterval(() => {
      if (messageIndex < this.engagingMessages.length) {
        this.toastr.clear();
        this.toastr.info(this.engagingMessages[messageIndex], '', {
          disableTimeOut: true,
          closeButton: true,
        });
        messageIndex++;
      } else {
        // Loop the messages once all are shown
        messageIndex = 0;
      }
    }, 5000); // Change message every 2 seconds

    return intervalId;
  };

  clearEngagingToaster = (intervalId: any, finalMessage: string) => {
    clearInterval(intervalId); // Stop the interval updates
    this.toastr.clear(); // Clear the previous toast
    this.toastr.success(finalMessage, '', { timeOut: 3000 }); // Show the success message
  };

  fileUploaded: boolean = false;

  async processWithAI() {
    if (this.fieldTemplateID > 0) {
      if (this.uploadedFiles.length == 1) {
        this.forSingleUpload();
      }
      if (this.uploadedFiles.length > 1) {
        this.forMultipleUpload();
      }
    } else {
      this.forSingleUpload();
    }
  }

  // forSingleUpload() {
  //   this.loaderService.show();
  //   const chunkSize = 10 * 1024 * 1024;
  //   const files = this.uploadedFiles;

  //   const processFile = async (file: File) => {

  //     //  STEP 1: PDF Password Check (inline, no helper)
  //     if (file.type === 'application/pdf') {
  //       try {
  //         const pdfCheck: any = await new Promise((resolve, reject) => {
  //           this.checkpdfPasswordProtected(file).subscribe({
  //             next: res => resolve(res),
  //             error: err => reject(err)
  //           });
  //         });

  //         if (!pdfCheck?.data) {
  //           this.toastr.warning(
  //             `"${file.name}" is password protected and cannot be processed. Please upload a new file without a password.`,
  //             '',
  //             { timeOut: 7000 }
  //           );
  //           this.loaderService.hide();
  //           return;
  //         }

  //       } catch {
  //         this.loaderService.hide();
  //         this.toastr.warning(
  //                 '<b>Almost There — Your File Is Still Over 5MB</b><br/><br/>' +
  //                 'We ran a compression, but the document is still over the upload limit.<br/><br/>' +
  //                 '<a href="https://smallpdf.com/compress-pdf" target="_blank" style="color:#fff; text-decoration:underline;">Click here to compress your file</a><br/><br/>' +
  //                 '1) Choose "Basic Compression"<br/>' +
  //                 '2) Re-upload it here',
  //                 '',
  //                 { timeOut: 10000, enableHtml: true }
  //               );
  //         return;
  //       }
  //     }

  //     //  STEP 2: Clean file
  //     const cleaned = this.cleanAndValidateFile(file);
  //     if (!cleaned) {
  //       this.loaderService.hide();
  //       return;
  //     }

  //     const { file: newFile, name, ext } = cleaned;
  //     const finalFileName = `${name}.${ext}`;

  //     const totalChunks = Math.ceil(newFile.size / chunkSize);
  //     let intervalId: any;

  //     for (let i = 0; i < totalChunks; i++) {

  //       const chunk = newFile.slice(i * chunkSize, Math.min((i + 1) * chunkSize, newFile.size));

  //       const formData = new FormData();
  //       formData.append('fileChunk', chunk);
  //       formData.append('chunkIndex', i.toString());
  //       formData.append('totalChunks', totalChunks.toString());

  //       formData.append('fileName', finalFileName);
  //       formData.append('FileDetailList', `${name}|${ext}`);

  //       formData.append('ParentID', this.parentId.toString());
  //       formData.append('UserID', this.currentUser.UID);
  //       formData.append('OrganizationID', this.organizationId);
  //       formData.append('OfficeID', this.myOfficeID);
  //       formData.append('DatabaseID', this.databaseId);
  //       formData.append('coreId', this.transactionId.toString());
  //       formData.append('templateId', this.fieldTemplateID.toString());
  //       formData.append('requestFrom', "1");

  //       try {
  //         this.fileUploaded = false;

  //         const response = await this.coreService
  //           .uploadChunkForMultipleUploadWithSelectedTemplate(formData)
  //           .toPromise();

  //         if (response?.data === 2) {
  //           this.fileUploaded = true;
  //           this.toastr.warning(`${finalFileName} already exists.`, '', { timeOut: 2000 });
  //           return;
  //         } else {

  //           if (i + 1 === totalChunks) {
  //             intervalId = this.showEngagingToaster(finalFileName);
  //           }

  //           this.toastr.clear();
  //           this.toastr.info(`Chunk ${i + 1}/${totalChunks} uploaded for ${finalFileName}`, '', {
  //             timeOut: 1000,
  //           });
  //         }

  //       } catch {
  //         this.loaderService.hide();
  //         this.toastr.error(`Error uploading ${finalFileName}`, '', { timeOut: 3000 });
  //         return;
  //       }
  //     }

  //     if (intervalId && !this.fileUploaded) {
  //       this.clearEngagingToaster(intervalId, `File ${finalFileName} uploaded successfully!`);
  //       this.closepopup();
  //     }
  //   };

  //   (async () => {
  //     for (const file of files) {
  //       await processFile(file);
  //     }
  //     this.loaderService.hide();
  //   })();
  // }

  async forSingleUpload() {

    this.loaderService.show();

    const chunkSize = 10 * 1024 * 1024; // 10 MB
    const maxFileSize = 20 * 1024 * 1024; // 20 MB

    const files = this.uploadedFiles;

    const processFile = async (file: File): Promise<boolean> => {

      // STEP 0: File Size Validation
      if (file.size > maxFileSize) {

        const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

        this.toastr.warning(
          `"${file.name}" is ${sizeInMB} MB. Maximum allowed file size is 20 MB.`,
          '',
          { timeOut: 9000 }
        );

        this.uploadedFiles = [];
        this.loaderService.hide();

        return false;
      }

      // STEP 1: PDF Password Check (Local)
      if (file.type === 'application/pdf') {

        const isPasswordProtected = await new Promise<boolean>((resolve) => {

          const reader = new FileReader();

          reader.onload = (e: any) => {

            try {

              const uint8Array = new Uint8Array(e.target.result);

              // Convert PDF binary to text
              const pdfText = new TextDecoder().decode(uint8Array);

              // Detect encryption
              resolve(pdfText.includes('/Encrypt'));

            } catch {
              resolve(false);
            }
          };

          reader.onerror = () => resolve(false);

          reader.readAsArrayBuffer(file);
        });

        if (isPasswordProtected) {

          this.toastr.warning(
            `"${file.name}" is password protected and cannot be processed. Please upload a new file without a password.`,
            '',
            { timeOut: 9000 }
          );

          this.uploadedFiles = [];
          this.loaderService.hide();

          return false;
        }
      }

      // STEP 2: Clean file
      const cleaned = this.cleanAndValidateFile(file);

      if (!cleaned) {

        this.uploadedFiles = [];
        this.loaderService.hide();

        return false;
      }

      const { file: newFile, name, ext } = cleaned;
      const finalFileName = `${name}.${ext}`;

      // STEP 3: Chunk Upload
      const totalChunks = Math.ceil(newFile.size / chunkSize);

      let intervalId: any;

      for (let i = 0; i < totalChunks; i++) {

        const chunk = newFile.slice(
          i * chunkSize,
          Math.min((i + 1) * chunkSize, newFile.size)
        );

        const formData = new FormData();

        formData.append('fileChunk', chunk);
        formData.append('chunkIndex', i.toString());
        formData.append('totalChunks', totalChunks.toString());

        formData.append('fileName', finalFileName);
        formData.append('FileDetailList', `${name}|${ext}`);

        formData.append('ParentID', this.parentId.toString());
        formData.append('UserID', this.currentUser.UID);
        formData.append('OrganizationID', this.organizationId);
        formData.append('OfficeID', this.myOfficeID);
        formData.append('DatabaseID', this.databaseId);
        formData.append('coreId', this.transactionId.toString());
        formData.append('templateId', this.fieldTemplateID.toString());
        formData.append('requestFrom', '1');

        try {

          this.fileUploaded = false;

          const response = await this.coreService
            .uploadChunkForMultipleUploadWithSelectedTemplate(formData)
            .toPromise();

          if (response?.data === 2) {

            this.fileUploaded = true;

            this.toastr.warning(
              `${finalFileName} already exists.`,
              '',
              { timeOut: 2000 }
            );

            return false;
          }

          if (i + 1 === totalChunks) {
            intervalId = this.showEngagingToaster(finalFileName);
          }

          this.toastr.clear();

          this.toastr.info(
            `Chunk ${i + 1}/${totalChunks} uploaded for ${finalFileName}`,
            '',
            { timeOut: 5000 }
          );

        } catch {

          this.loaderService.hide();

          this.toastr.error(
            `Error uploading ${finalFileName}`,
            '',
            { timeOut: 5000 }
          );

          return false;
        }
      }

      if (intervalId && !this.fileUploaded) {

        this.clearEngagingToaster(
          intervalId,
          `File ${finalFileName} uploaded successfully!`
        );

        this.closepopup();
      }

      return true;
    };

    try {

      for (const file of files) {

        const success = await processFile(file);

        // Stop processing remaining files if validation/upload fails
        if (!success) {
          break;
        }
      }

    } finally {

      this.loaderService.hide();
    }
  }

  async forMultipleUpload() {

    this.loaderService.show();

    const chunkSize = 10 * 1024 * 1024; // 10 MB
    const maxFileSize = 20 * 1024 * 1024; // 20 MB

    const files = this.uploadedFiles;

    const formData = new FormData();
    let counter = 0;

    try {

      for (const file of files) {

        // STEP 0: File Size Validation
        if (file.size > maxFileSize) {

          const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

          this.toastr.warning(
            `"${file.name}" is ${sizeInMB} MB. Maximum allowed file size is 20 MB.`,
            '',
            { timeOut: 9000 }
          );

          this.uploadedFiles = [];
          this.loaderService.hide();

          return;
        }

        // STEP 1: PDF Password Check (Local)
        if (file.type === 'application/pdf') {

          const isPasswordProtected = await new Promise<boolean>((resolve) => {

            const reader = new FileReader();

            reader.onload = (e: any) => {

              try {

                const uint8Array = new Uint8Array(e.target.result);

                // Convert PDF binary to text
                const pdfText = new TextDecoder().decode(uint8Array);

                // Detect encryption
                resolve(pdfText.includes('/Encrypt'));

              } catch {
                resolve(false);
              }
            };

            reader.onerror = () => resolve(false);

            reader.readAsArrayBuffer(file);
          });

          if (isPasswordProtected) {

            this.toastr.warning(
              `"${file.name}" is password protected and cannot be processed. Please upload a new file without a password.`,
              '',
              { timeOut: 9000 }
            );

            this.uploadedFiles = [];
            this.loaderService.hide();

            return;
          }
        }

        // STEP 2: Clean File
        const cleaned = this.cleanAndValidateFile(file);

        if (!cleaned) {

          this.uploadedFiles = [];
          this.loaderService.hide();

          return;
        }

        const { file: newFile, name, ext } = cleaned;

        const finalFileName = `${name}.${ext}`;

        const totalChunks = Math.ceil(newFile.size / chunkSize);

        // STEP 3: Create Chunks
        for (let i = 0; i < totalChunks; i++) {

          const chunk = newFile.slice(
            i * chunkSize,
            Math.min((i + 1) * chunkSize, newFile.size)
          );

          formData.append(`FileChunks[${counter}].FileChunk`, chunk);
          formData.append(`FileChunks[${counter}].FileName`, finalFileName);
          formData.append(`FileChunks[${counter}].ChunkIndex`, i.toString());
          formData.append(`FileChunks[${counter}].TotalChunks`, totalChunks.toString());
          formData.append(`FileChunks[${counter}].FileDetail`, `${name}|${ext}`);

          counter++;
        }
      }

      // STEP 4: Common Parameters
      formData.append('ParentID', this.parentId.toString());
      formData.append('UserID', this.currentUser.UID);
      formData.append('OrganizationID', this.organizationId.toString());
      formData.append('OfficeID', this.myOfficeID.toString());
      formData.append('DatabaseID', this.databaseId.toString());
      formData.append('CoreId', this.transactionId.toString());
      formData.append('TemplateId', this.fieldTemplateID.toString());
      formData.append('RequestFrom', '1');

      // STEP 5: Upload API
      const response = await this.coreService
        .uploadChunkForMultipleFiles(formData)
        .toPromise();

      if (response?.data === 2) {

        this.toastr.warning(
          'Some files already exist.',
          '',
          { timeOut: 2000 }
        );

      } else {

        this.toastr.success(
          'All files uploaded successfully!',
          '',
          { timeOut: 4000 }
        );
      }

      this.closepopup();

    } catch {

      this.toastr.error(
        'Error during upload.',
        '',
        { timeOut: 5000 }
      );

    } finally {

      this.loaderService.hide();
    }
  }


  // async forMultipleUpload() {
  //   this.loaderService.show();
  //   const chunkSize = 10 * 1024 * 1024;
  //   const files = this.uploadedFiles;

  //   const formData = new FormData();
  //   let counter = 0;

  //   for (const file of files) {

  //     //  STEP 1: PDF Password Check
  //     if (file.type === 'application/pdf') {
  //       try {
  //         const pdfCheck: any = await new Promise((resolve, reject) => {
  //           this.checkpdfPasswordProtected(file).subscribe({
  //             next: res => resolve(res),
  //             error: err => reject(err)
  //           });
  //         });

  //         if (!pdfCheck?.data) {
  //           this.toastr.warning(
  //             `"${file.name}" is password protected and cannot be processed. Please upload a new file without a password.`,
  //             '',
  //             { timeOut: 5000 }
  //           );
  //           this.loaderService.hide();
  //           return;
  //         }

  //       } catch {
  //          this.toastr.warning(
  //                 '<b>Almost There — Your File Is Still Over 5MB</b><br/><br/>' +
  //                 'We ran a compression, but the document is still over the upload limit.<br/><br/>' +
  //                 '<a href="https://smallpdf.com/compress-pdf" target="_blank" style="color:#fff; text-decoration:underline;">Click here to compress your file</a><br/><br/>' +
  //                 '1) Choose "Basic Compression"<br/>' +
  //                 '2) Re-upload it here',
  //                 '',
  //                 { timeOut: 10000, enableHtml: true }
  //               );     
  //         this.loaderService.hide();
  //         return;
  //       }
  //     }

  //     //  STEP 2: Clean file
  //     const cleaned = this.cleanAndValidateFile(file);
  //     if (!cleaned) {
  //       this.loaderService.hide();
  //       return;
  //     }

  //     const { file: newFile, name, ext } = cleaned;
  //     const finalFileName = `${name}.${ext}`;

  //     const totalChunks = Math.ceil(newFile.size / chunkSize);

  //     for (let i = 0; i < totalChunks; i++) {

  //       const chunk = newFile.slice(
  //         i * chunkSize,
  //         Math.min((i + 1) * chunkSize, newFile.size)
  //       );

  //       formData.append(`FileChunks[${counter}].FileChunk`, chunk);
  //       formData.append(`FileChunks[${counter}].FileName`, finalFileName);
  //       formData.append(`FileChunks[${counter}].ChunkIndex`, i.toString());
  //       formData.append(`FileChunks[${counter}].TotalChunks`, totalChunks.toString());
  //       formData.append(`FileChunks[${counter}].FileDetail`, `${name}|${ext}`);

  //       counter++;
  //     }
  //   }

  //   //  STEP 3: Common params
  //   formData.append('ParentID', this.parentId.toString());
  //   formData.append('UserID', this.currentUser.UID);
  //   formData.append('OrganizationID', this.organizationId.toString());
  //   formData.append('OfficeID', this.myOfficeID.toString());
  //   formData.append('DatabaseID', this.databaseId.toString());
  //   formData.append('CoreId', this.transactionId.toString());
  //   formData.append('TemplateId', this.fieldTemplateID.toString());
  //   formData.append('RequestFrom', '1');

  //   try {
  //     const response = await this.coreService
  //       .uploadChunkForMultipleFiles(formData)
  //       .toPromise();

  //     if (response?.data === 2) {
  //       this.toastr.warning(`Some files already exist.`, '', { timeOut: 2000 });
  //     } else {
  //       this.toastr.success(`All files uploaded successfully!`, '', { timeOut: 2000 });
  //     }

  //     this.closepopup();

  //   } catch {
  //     this.toastr.error(`Error during upload.`, '', { timeOut: 3000 });
  //   } finally {
  //     this.loaderService.hide();
  //   }
  // }


  checkpdfPasswordProtected(file: File): Observable<any> {
    const reader = new FileReader();
    return new Observable(observer => {
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const byteArray = Array.from(new Uint8Array(arrayBuffer));
        this.coreService.canThisPdfOpenforModifyByBytes(byteArray).subscribe({
          next: (res) => {
            observer.next(res);
            observer.complete();
          },
          error: (err) => observer.error(err)
        });
      };

      reader.onerror = (err) => observer.error(err);

      reader.readAsArrayBuffer(file);
    });
  }

  cleanAndValidateFile(file: File): { file: File, name: string, ext: string } | null {

    const invalidCharsRegex = /[ #?%+&:;@="<>\\|^`{}\[\]]/g;

    const originalFileName = file.name;
    const lastDotIndex = originalFileName.lastIndexOf('.');

    if (lastDotIndex === -1) {
      this.toastr.warning(`Invalid file format: "${originalFileName}"`, '', { timeOut: 3000 });
      return null;
    }

    let nameWithoutExt = originalFileName.substring(0, lastDotIndex);
    let extension = originalFileName.substring(lastDotIndex + 1);

    //  Clean
    let cleanedName = nameWithoutExt.replace(invalidCharsRegex, '');
    // Remove spaces      
    cleanedName = cleanedName.replace(/\s+/g, '');

    //  Empty check
    if (!cleanedName) {
      this.toastr.warning(`Invalid file name after cleanup: "${originalFileName}"`, '', { timeOut: 3000 });
      return null;
    }

    // Length check
    if (cleanedName.length > 120) {
      this.toastr.warning('File name up to 120 characters only supported.', '', { timeOut: 3000 });
      return null;
    }

    // Remove numbering pattern
    // cleanedName = cleanedName.replace(/(_\d+(\.\d+)*|\.\d+)+$/, '');

    const finalFileName = `${cleanedName}.${extension}`;

    // Create renamed file
    const newFile = new File([file], finalFileName, { type: file.type });

    return {
      file: newFile,
      name: cleanedName,
      ext: extension
    };
  }


  // forSingleUpload(){
  //   this.loaderService.show();
  //   const chunkSize = 10 * 1024 * 1024; // 5 MB per chunk
  //   const UploadedFilesDragZone = this.uploadedFiles;//Array.from(input.files); // Convert FileList to Array

  //   const processFile = async (file: File) => {
  //     // Remove brackets, hash, comma, and special characters except underscore and dot (for file extension)
  //     const fileName = file.name.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

  //     // Validate file name length
  //     if (fileName.split('.')[0].length > 120) {
  //       this.toastr.warning(
  //         'File name up to 120 characters only supported, please rename the file.',
  //         '',
  //         { timeOut: 3000 }
  //       );       
  //       this.loaderService.hide();
  //       return;
  //     }

  //     var newfilename = fileName.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');

  //     var documentNameSplit = newfilename.split('.');

  //     const documentName = documentNameSplit[0];
  //     const documentType = documentNameSplit[1];

  //     const totalChunks = Math.ceil(file.size / chunkSize);

  //     let intervalId: any;
  //     for (let i = 0; i < totalChunks; i++) {
  //       const start = i * chunkSize;
  //       const end = Math.min(start + chunkSize, file.size);
  //       const chunk = file.slice(start, end);

  //       const formData = new FormData();
  //       formData.append('fileChunk', chunk);
  //       formData.append('chunkIndex', i.toString());
  //       formData.append('totalChunks', totalChunks.toString());
  //       formData.append('fileName', fileName);
  //       formData.append('FileDetailList', `${documentName}|${documentType}`);
  //       formData.append('ParentID', this.parentId.toString());
  //       formData.append('UserID', this.currentUser.UID);
  //       formData.append('OrganizationID', this.organizationId);
  //       formData.append('OfficeID', this.myOfficeID);
  //       formData.append('DatabaseID', this.databaseId);
  //       formData.append('coreId', this.transactionId.toString());
  //       formData.append('templateId', this.fieldTemplateID.toString());
  //       formData.append('requestFrom', "1");
  //       try {
  //         this.fileUploaded = false;
  //         const response = await this.coreService.uploadChunkForMultipleUploadWithSelectedTemplate(formData).toPromise();
  //         if (response?.data === 2) {
  //           this.fileUploaded = true;
  //           this.toastr.warning(`${fileName} already exists.`, '', {
  //             timeOut: 2000,
  //           });
  //         } else {
  //           if (i + 1 == totalChunks) {
  //             intervalId = this.showEngagingToaster(fileName);
  //           }
  //           this.toastr.clear();
  //           this.toastr.info(`Chunk ${i + 1}/${totalChunks} uploaded for ${fileName}`, '', {
  //             timeOut: 1000,
  //           });
  //         }
  //       } catch (error) {
  //         this.loaderService.hide();
  //         this.toastr.error(`An error occurred during chunk upload for ${fileName}.`, '', {
  //           timeOut: 3000,
  //         });
  //         return;
  //       }
  //     }
  //     if (intervalId)
  //       if (this.fileUploaded == false) {
  //         this.clearEngagingToaster(intervalId, `File ${fileName} uploaded successfully!`);
  //         this.closepopup();
  //       }
  //   };

  //   const uploadFiles = async () => {
  //     for (const file of UploadedFilesDragZone) {
  //       await processFile(file);
  //     }
  //     this.loaderService.hide();
  //   };

  //   uploadFiles();
  // }


  // async forMultipleUpload() {
  // this.loaderService.show();
  // const chunkSize = 10 * 1024 * 1024; // 10 MB per chunk
  // const UploadedFilesDragZone = this.uploadedFiles;

  // const formData = new FormData();
  // let fileChunkCounter = 0;

  // for (const file of UploadedFilesDragZone) {
  //   const fileName = file.name.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

  //   // Validate filename
  //   if (fileName.split('.')[0].length > 120) {
  //     this.toastr.warning(
  //       'File name up to 120 characters only supported, please rename the file.',
  //       '',
  //       { timeOut: 3000 }
  //     );
  //     this.loaderService.hide();
  //     return;
  //   }

  //   const newfilename = fileName.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
  //   const documentNameSplit = newfilename.split('.');
  //   const documentName = documentNameSplit[0];
  //   const documentType = documentNameSplit[1];
  //   const totalChunks = Math.ceil(file.size / chunkSize);

  //   for (let i = 0; i < totalChunks; i++) {
  //     const start = i * chunkSize;
  //     const end = Math.min(start + chunkSize, file.size);
  //     const chunk = file.slice(start, end);

  //     // Append each chunk as a separate entry in the FileChunks list
  //     formData.append(`FileChunks[${fileChunkCounter}].FileChunk`, chunk);
  //     formData.append(`FileChunks[${fileChunkCounter}].FileName`, fileName);
  //     formData.append(`FileChunks[${fileChunkCounter}].ChunkIndex`, i.toString());
  //     formData.append(`FileChunks[${fileChunkCounter}].TotalChunks`, totalChunks.toString());
  //     formData.append(
  //       `FileChunks[${fileChunkCounter}].FileDetail`,
  //       `${documentName}|${documentType}`
  //     );

  //     fileChunkCounter++;
  //   }
  // }

  // // Common metadata (once per request)
  // formData.append('ParentID', this.parentId.toString());
  // formData.append('UserID', this.currentUser.UID);
  // formData.append('OrganizationID', this.organizationId.toString());
  // formData.append('OfficeID', this.myOfficeID.toString());
  // formData.append('DatabaseID', this.databaseId.toString());
  // formData.append('CoreId', this.transactionId.toString());
  // formData.append('TemplateId', this.fieldTemplateID.toString());
  // formData.append('RequestFrom', '1');

  // try {
  //   const response = await this.coreService
  //     .uploadChunkForMultipleFiles(formData)
  //     .toPromise();

  //   if (response?.data === 2) {
  //     this.toastr.warning(`Some files already exist.`, '', { timeOut: 2000 });
  //   } else {
  //     this.toastr.success(`All files uploaded successfully!`, '', { timeOut: 2000 });
  //   }

  //   this.closepopup();
  // } catch (error) {
  //   this.toastr.error(`An error occurred during chunk upload.`, '', { timeOut: 3000 });
  // } finally {
  //   this.loaderService.hide();
  // }
  // }


  isDragging = false;

  onFileSelected(event: any) {
    const files: FileList = event.target.files;
    this.addFiles(files);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault(); // necessary to allow dropping
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.addFiles(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  }

  private addFiles(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      this.uploadedFiles.push(files[i]);
    }
  }



}


